<ng-container *ngTemplateOutlet="topbar"></ng-container>
<div id="topbar-fixed" [class.visible]="isTopbarFixed">
  <ng-container *ngTemplateOutlet="topbar"></ng-container>
</div>

<ng-template #topbar>
  <div id="topbar" [class.shadowFixed]="isTopbarFixed">
    <div id="title">
      <qr-button
        *ngIf="isBackButtonVisible"
        id="button-back"
        [config]="buttonBack"
        matTooltip="Regresar"
        (click)="backClick()"
      ></qr-button>
      <h2 class="heading-01-semi-bold">{{ this.title }}</h2>
    </div>
    <div *ngIf="isDropdownOfficeVisible">
      <qr-dropdown
        *ngIf="listUsers && listUsers?.length != 0"
        [config]="dropdownOffices"
        [selected]="dropdownOfficesSelected"
        (change)="dropdownOfficeChange($event)"
      ></qr-dropdown>
    </div>
  </div>
</ng-template>
